import { connect } from 'react-redux';

import { IApplicationState } from '@store';
import { resetPassword } from '@store/actions';

import ResetPassword, {
  ResetPasswordStateProps,
  ResetPasswordDispatchProps,
} from '../components/login/ResetPassword';

interface IStateToProps extends Pick<IApplicationState, 'resetPassword'> {}

const mapStateToProps = ({
  resetPassword,
}: IStateToProps): ResetPasswordStateProps => ({
  error: resetPassword.error,
  status: resetPassword.status,
});

const mapDispatchToProps = (dispatch: any): ResetPasswordDispatchProps => ({
  resetPassword: (email: string) => dispatch(resetPassword({ email })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
